class BuilderDataToken {
  constructor($scope, FEService, TemplateService) {
    'ngInject';
    this.$scope = $scope;
    this.fe = FEService;
    this.ts = TemplateService;
    this.placeholderIcon = null;
    this.fieldSchema = null;
    this.showLabel = true;
    this.errorState = false;
    this.isMissing = false;
  }

  async $onInit() {
    await this.fe.waitForBindings(["token", "reference"], this.$scope);

    this.fieldSchema = this.token?.fieldSchema;
    this.isRadio = !!this.token.options?.choice && ['radio-control'].includes(this.token.control.type);
    this.isMultiCheckbox = !!this.token.options?.choice && ['multicheckbox-control'].includes(this.token.control.type);
    this.isOption = this.isRadio || this.isMultiCheckbox;
    this.isMissing = (!this.fieldSchema || this.token.control.type === 'not-found');
    this.errorState = this.isMissing || !this.reference?.name;
    
    this.setTokenFlags();
    this.handleSchemaIcons();
    this.setLabelAndTitle();
    
    const wFormat = this.$scope.$watch('$ctrl.token.format', (newFormat, oldFormat) => { 
      (newFormat || oldFormat) && this.setPlaceholderIcon(newFormat);
    });
    const wLabel = this.$scope.$watch('$ctrl.token.options', _ => this.optionsUpdated());

    this.$scope.$on('$destroy', () => { wFormat(); wLabel() });
  }
  
  handleSchemaIcons() {
    if (this.fieldSchema?.fieldType === 'checkbox') {
      this.setPlaceholderIcon('checkbox');
      this.showLabel = false;
    }
  }

  optionsUpdated() {
    this.setLabelAndTitle();
  }
  
  setTokenFlags() {
    this.ts.setTokenBehaviorsFlag(this.token);
  }

  setPlaceholderIcon(format) {
    this.placeholderIcon = ((format || '') === 'signature') ? null : `/img/placeholder-${format}.svg`;
  }

  setLabelAndTitle() {
    const refName = this.reference?.name || 'Missing table!';
    const origLabel = this.fieldSchema?.label || 'Missing!';
    const customLabel = this.token.options?.label;

    this.title = `${refName}\n${origLabel}` + 
      `${(this.token.options?.choice) ? `\nChoice: ${this.token.options?.choice.value}` : ''}`;
    this.label = (typeof customLabel === 'string') ? customLabel : origLabel;
  }
}

export default {
  bindings: {
    token: "=",
    reference: '<'
  },
  templateUrl: "form-builder/builder-data-token/builder-data-token.component.html",
  controller: BuilderDataToken
};